import React, { Component } from 'react';
import InputOnClick from '../InputOnClick.js';

import onClickOutside from "react-onclickoutside";

let InputOnClickWithOnClickOutside = onClickOutside(InputOnClick);

class LocaleListItem extends Component {
  constructor (props) {
    super(props);

    this.state = {
      isBusy: false
    }
  
    this.itemKey = this.props.locale.props.key;
    this.onTextUpdate = this.onTextUpdate.bind(this);
    this.onDuplicate = this.onDuplicate.bind(this);
    this.onDisable = this.onDisable.bind(this);
  }

	onTextUpdate = (param) => (value) => {
    const that = this;

    this.props.locale.props[param] = (value === "") ? null : value;

    return new Promise((resolve, reject) => {
      let updated = that.props.updater(that.itemKey, param, that.props.locale.props[param]);
      if (updated) {
        updated.then(function () {
          that.itemKey = that.props.locale.props.key;
          that.props.localesContext.updater(that.props.locale);
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      }
      reject(null);
    });
	}

  onRenable = (event) => {
    const that = this;

    this.props.locale.props.deleted = false;

    let renabled = this.props.updater(this.itemKey, 'deleted', null);
    if (renabled) {
      renabled.then(function () {
        that.props.localesContext.updater(that.props.locale);
      });
    }
  }

  onDisable = (event) => {
    const that = this;

    let deleted = this.props.deleter(this.itemKey);
    if (deleted) {
      deleted.then(function () {
        that.props.locale.props.deleted = true;
        that.props.localesContext.updater(that.props.locale);
      });
    }
  }

  onDuplicate (e) { 
    const that = this;

    this.setState({ isBusy: true });

    this.props.duplicator(this.itemKey)
      .then(function (locale) {
        that.setState({ isBusy: false });
        that.props.localesContext.adder(locale);
      })
      .catch(function (error) {
        that.setState({ isBusy: false });
        throw error;
      });
  }

  render () {
    const that = this;

    let rowStyle = {};

    if (this.state.isBusy) {
      rowStyle.pointerEvents = 'none';
      rowStyle.opacity = '0.4';
    }

    if (this.props.locale.props.deleted) {
      rowStyle.backgroundColor = "black";
      rowStyle.color = "white";
    }

    if (this.props.locale.props.deleted)
    {
      return (
        <tr style={{backgroundColor: 'black', color: 'white'}}>
          <td style={{verticalAlign: 'middle'}} title={this.props.locale.props.key}>
            {this.props.locale.props.key}
          </td>
          <td style={{verticalAlign: 'middle'}} title={this.props.locale.props.name}>
            {this.props.locale.props.name}
          </td>
          <td style={{verticalAlign: 'middle', textAlign: 'center'}}>
            <span style={{marginRight: '10px'}}>
              <a className="button is-warning" onClick={that.onRenable}>Renable</a>
            </span>
          </td>
        </tr>
      );
    }
    else
    {
      return (
        <tr style={rowStyle}>
          <td style={{verticalAlign: 'middle'}}>
            <InputOnClickWithOnClickOutside 
              key={this.props.locale.props.key + 'key.input'} 
              onEnter={this.onTextUpdate('key')} 
              className="locale.locales.item input" 
              defaultValue={this.props.locale.props.key} 
            />
          </td>
          <td style={{verticalAlign: 'middle'}}>
            <InputOnClickWithOnClickOutside 
              key={this.props.locale.props.key + 'name.input'} 
              onEnter={this.onTextUpdate('name')} 
              className="locale.locales.item input"
              defaultValue={this.props.locale.props.name} 
            />
          </td>
          <td style={{verticalAlign: 'middle', textAlign: 'center'}}>
            <span style={{marginRight: '10px'}}>
              <a className="button is-danger" onClick={that.onDisable}>Disable</a>
            </span>
            <span style={{marginRight: '10px'}}>
              <a className="button is-warning" onClick={that.onDuplicate}>Duplicate</a>
            </span>
          </td>
        </tr>
      );
    }
  }
}

export default LocaleListItem;


// WEBPACK FOOTER //
// ./src/Components/Locale/LocaleListItem.js